import { http } from "@next-core/http";
/**
 * @description 批量契约搜索
 * @endpoint POST /api/v1/contract/batch_search
 */
export const ContractCenterApi_batchSearchContract = async (data, options) => /**! @contract easyops.api.next_builder.contract_center.BatchSearchContract@1.0.0 */(await http.post("api/gateway/next_builder.contract_center.BatchSearchContract/api/v1/contract/batch_search", data, options)).data;
//# sourceMappingURL=batchSearchContract.js.map